module.exports = __webpack_public_path__ + "static/media/anger-reading.b007a130.jpg";